import { useTranslation } from 'react-i18next';

import { EventSummary } from './event-summary';
import { ErrorPage } from '../../../../components/error-page';
import { useUserPermissions } from '../../../hooks/user-permissions';

import accessDeniedOperatorImage from '../../../../assets/access-denied-operator.svg';

export function EventSummaryGuard() {
  const { isAccessToEventSetupAllowed } = useUserPermissions();
  const { t } = useTranslation();

  if (!isAccessToEventSetupAllowed) {
    return (
      <ErrorPage
        data-testid="access-denied"
        title={t('common.accessDenied.title')}
        subTitle={t('common.accessDenied.subTitle')}
        image={accessDeniedOperatorImage}
        style={{ gridArea: 'section', height: 'unset', background: 'none' }}
      />
    );
  }

  return <EventSummary />;
}
